import React from "react"
import { Result } from "antd"
import * as COMMONS from "common/common"

const LineFriend = props => {
  return (
    <div className="flex h-screen">
      <div className="m-auto">
        <Result
          status="403"
          title="友だち追加してください"
          subTitle={COMMONS.ERROR_LINE_FRIEND_MSG}
        />
      </div>
    </div>
  )
}

export default LineFriend
